import ApiService from "@/common/api/api.service";

let apiBasePath = "Nota";
const NotasService = {
  async buscarNotasPorFiltro(form) {
    let { data } = await ApiService.get(
      `${apiBasePath}/obter-notas-parciais?anoLetivoId=${form.anoLetivoId}&segmentacaoId=${form.segmentacaoId}&disciplinaId=${form.disciplinaId}`,
      form
    );
    return data;
  },
};

export default NotasService;
